import { Observable } from "rxjs";
import { AllEvents } from "./all-events";
import { Event } from "./types";

export const ofType = <A extends AllEvents, B extends AllEvents["type"]>(
  x: B
): ((
  y: Observable<A>
) => Observable<A extends Event<B, infer C> ? C : never>) => {
  return (y) => {
    return new Observable((subscriber) => {
      const sub = y.subscribe((val) => {
        if (val.type === x) {
          // TODO Fix typing
          subscriber.next(val.payload as any);
        }
      });

      return () => {
        sub.unsubscribe();
      };
    });
  };
};
